<template>
    <b-overlay :show="loading" rounded="sm">
        <div class="asset-frequency">
            <b-card :title="componentName" class="inner-page p-3">
                <b-card-body>
                    <b-table :items="items" :fields="fields" class="mt-2">
                        <template #cell(control)="{ index, item }">
                            <b-button :id="'add-freq-btn-'+index" class="test-add-freq-btn" v-if="index == items.length - 1 && hasPermissionCreate" variant="link"
                                @click="addFrequency(item)"><img src="@/assets/images/icon/blue-add.svg" />
                            </b-button>
                            <b-button :id="'delete-freq-btn-'+index"  v-if="index !== items.length - 1 && hasPermissionDelete" variant="pink-button"
                                class="ms-3 test-delete-freq-btn" @click="deleteNote(index)"><img src="@/assets/images/icon/delete.svg" />
                            </b-button>
                        </template>

                        <template #cell(name)="{ index, item, value }">
                            <b-form-input v-if="index == items.length - 1" :id="`input-name${index}`"
                                :placeholder="$translate('name')" class="test-input-name" v-model="item.name" type="text"></b-form-input>

                            <span v-else>{{ value }}</span>
                        </template>

                        <template #cell(value)="{ index, item, value }">
                            <b-form-input v-if="index == items.length - 1" :id="`input-value${index}`"
                                :placeholder="$translate('value')" class="test-input-number" v-model="item.value" type="number"></b-form-input>

                            <span v-else>{{ value }}</span>
                        </template>
                    </b-table>
                </b-card-body>
            </b-card>
        </div>
    </b-overlay>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'assetFrequencies',
    mixins: [popupMixins, permissionsMixins],
    data: () => ({
        model: {
            frequencies: [],
        },
        updating: false,
        loading: false
    }),

    computed: {
        fields() {
            return [
                { key: 'name', label: this.$translate('name') },
                { key: 'value', label: `${this.$translate('days')}(1-365)` },
                { key: 'control', label: '' },
            ]
        },
        componentName() { return this.$translate('asset_frequency') },
        assetFrequencies() {
            const assetFrequencies =
                this.$store.getters['company/assetFrequencies']
            console.log('computed assetFrequencies', assetFrequencies)
            return assetFrequencies
        },
        items() {
            return [...this.model.frequencies, { name: '', value: '' }]
        },
        settingKeys() {
            return this.$store.state.company.settingKeys.assetFrequencyKey
        },
    },

    watch: {
        assetFrequencies: {
            handler: function (val) {
                console.log('watch assetFrequencies', val)
                this.updateModel(val)
            },
            deep: true,
        },
    },

    async mounted() {
        console.log('this.settingKeys', this.settingKeys)
        await this.$store.dispatch(
            'company/fetchConfiguration',
            this.settingKeys
        )
        this.$nextTick(() => {
            this.updateModel(this.assetFrequencies)
        })
    },

    methods: {
        updateModel(assetFrequencies) {
            console.log('update point reached')
            console.log('update assetFrequencies', assetFrequencies)
            let frequencies = assetFrequencies.frequencies || []
            this.model = { frequencies }
            console.log('update model', this.model)
        },

        async updateSettings(type, name,message) {
            try {
                this.updating = true
                const text_value = JSON.stringify(this.model)
                const bool_value = false

               await this.$store.dispatch('company/updateConfiguration', {
                    key: this.settingKeys,
                    text_value,
                    bool_value,
                })

                this.genericToast(this.componentName, type, 'success', `"${name}" ${message}`)


            } catch (error) {
                console.log(error)
                this.doToast(this.$translate('error'), error.message, 'danger')
            } finally {
                this.updating = false
            }
        },

        addFrequency: function ({ name, value }) {
            console.log('model', this.model)
            this.loading = true;
            try {
                if (!name || !value) {
                    throw Error(this.$translate('incomplete_asset_frequency_alert'))
                }

                if (!this.$escapeSpecialCharRule.test(name)) {
                    throw Error(this.$translate('name_regex_alert'))
                }
                if (!this.$escapeSpecialCharRule.test(value)) {
                    throw Error(this.$translate('value_regex_alert'))
                }

                if (this.model.frequencies.some(x => x.name === name)) {
                    throw Error(this.$translate('duplicate_asset_frequency_alert'))
                }

                if (!(value >= 1) || !(value <= 365)) {
                    throw Error(this.$translate('asset_frequency_limit_alert'))
                }

                this.model.frequencies.push({
                    name,
                    value,
                })
                this.$nextTick(() => {
                    this.updateSettings(this.$translate('created'), name, this.$translate('create_alert'))
                    this.loading = false;
                })
            } catch (error) {
                console.log(error.message)

                this.genericToast(`${this.componentName} ${this.$translate('error')}`, '', 'danger', error.message)

                this.loading = false;
            }


        },

        deleteNote: function (index) {
            console.log('>> ', index)
            this.loading = true;
            let currentFrequency = this.model.frequencies[index].name
            this.model.frequencies.splice(index, 1)
            this.$nextTick(() => {

                this.updateSettings(this.$translate('deleted'), currentFrequency, this.$translate('delete_alert'))
                this.loading = false;
            })
        },
    },
}
</script>
